export const sanitizeInput = (value: string): string =>
  value.replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const validateUserName = (value: string): boolean =>
  /^[a-zA-Z0-9_ ]{1,50}$/.test(value);

export const validateEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export const validatePassword = (value: string): boolean =>
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/.test(value);

export const checkConfirmPassowrd = (value1: string, value2: string): boolean =>
  value1 === value2;
